export const removeRedundantOptions = (array) => {
  const newArray = array.filter((item, index) => {
    const isRedundant = array.findIndex((item2) => item2.value === item.value)
    return isRedundant === index
  })
  return newArray
}
